export default {
  data() {
    return {
    };
  },
  computed: {
    //登录用户信息
    userInfo() {
      return JSON.parse(localStorage.userInfo) || this.$store.state.userInfo || null;
    },
    //是否登录
    isLogin() {
      return localStorage.isLogin || this.$store.state.isLogin || null;
    },
  },
  mounted() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // 可选，平滑滚动效果
    });
  },
  methods: {

  }
}